import React, { useState } from "react"
import Loader from "react-loader-spinner"
import Button from "../../../shared/components/atoms/button/button"
import ContactService from "../../../shared/services/contact-service"
import { siteUrl } from "../../../shared/utils/siteUrl"
import useDataPolicy from "../../../shared/hooks/useDataPolicy"
import UseChecksPolicy from "../../../shared/hooks/useChecksPolicy"
import DataPolicyService from "../../../shared/services/datapolicy-service"
import DataPolicy from "../../../shared/components/atoms/data-policy/data-policy"

const FormQuestion = ({
  urlTerminosCondiciones,
  urlPoliticaPrivacidadDatos,
  titleForm
}) => {
 const options = [
    {
      name: "Agradecimiento",
      value: "AGRADECIMIENTO",
    },
    {
      name: "Actualización datos personales",
      value: "ACTUALIZACION_DATOS",
    },
    {
      name: "Reclamo Producto Nosotras",
      value: "RECLAMO_PRODUCTO",
    },
    {
      name: "Solicitud de información",
      value: "SOLICITUD_INFORMACION_CONTACTO",
    },
    {
      name: "Sugerencia",
      value: "SUGERENCIA_CONTACTO",
    },
    {
      name: "Otro motivo",
      value: "OTRO_MOTIVO",
    },
  ]

  const [activeSelect, setactiveSelect] = useState(false)
  const homeLink = siteUrl + "/"

  const mailRegex = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/

  const defaultusernameValue = ""
  const defaultmailValue = ""
  const defaultphoneValue = ""
  const defaultactiveOption = { name: "Selecciona el motivo", value: "" }
  const defaultquestionValue = ""

  const [activeLoader, setactiveLoader] = useState(false)
  const [showSuccessQuestion, setshowSuccessQuestion] = useState(false)

  /* ---------- Input values ----------- */
  const [usernameValue, setusernameValue] = useState(defaultusernameValue)
  const [mailValue, setmailValue] = useState(defaultmailValue)
  const [phoneValue, setphoneValue] = useState(defaultphoneValue)
  const [activeOption, setactiveOption] = useState(defaultactiveOption)
  const [questionValue, setquestionValue] = useState(defaultquestionValue)
  const [tycValue, settycValue] = useState(true)
  const [policyValue, setpolicyValue] = useState(true)
  /* ---------- Input values ----------- */

  /* ---------- Error flags ----------- */
  const [usernameError, setusernameError] = useState(false)
  const [mailError, setmailError] = useState(false)
  const [phoneError, setphoneError] = useState(false)
  const [optionError, setoptionError] = useState(false)
  const [questionError, setquestionError] = useState(false)
  const [tycError, settycError] = useState(false)
  /* ---------- Error flags ----------- */

  /* ---------- Error Values ----------- */
  const [mailErrorValue, setmailErrorValue] = useState("")
  const [phoneErrorValue, setphoneErrorValue] = useState("")
  /* ---------- Error Values ----------- */

  // checks for data policy
  const { checksPolicy } = useDataPolicy()
  const {
    checks,
    changeCheck,
    isAllChecksTrue,
    getPayloadCheck,
  } = UseChecksPolicy()

  const handleSubmit = e => {
    e.preventDefault()

    if (!haveErrors() && !isDefaultValues()) {
      setactiveLoader(true)
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        'event': 'gaEvent',
        'eventTrigger': 'ContactUs',
        'eventCategory': 'Form',
        'eventAction': 'Submit',
        'eventLabel': 'Contact Us',
        'eventValue': undefined
      });

      var payload = {
        reason: activeOption.value,
        commentary: questionValue,
        emailUser: mailValue,
        name: usernameValue,
        cellphone:
          phoneValue === ""
            ? ""
            : process.env.COUNTRY_PHONE_PREFIX +
              parseInt(phoneValue).toString(),
        country: parseInt(process.env.COUNTRY_CODE),
        tycAccepted: 1,
        uytdAcepted: 1,
      }

      ContactService.postQuestion(payload)
        .then(res => {
          if (res.status === 200) {
            handleSubmitHabeasData()
            setshowSuccessQuestion(true)
          } else if (res.status == 400 && res.errorCode === "DEM010") {
            setmailError(true)
            setmailErrorValue(res.userMessage)
            setactiveLoader(false)
          } else {
            console.log(res)
            setactiveLoader(false)
          }
        })
        .catch(e => console.log(e))
    }
  }

  const handleSubmitHabeasData = () => {
    if (localStorage.getItem("TOKEN_INFO") !== null) {
      const token = JSON.parse(localStorage.getItem("TOKEN_INFO")).idToken
      const config = {
        headers: {
          Authorization: token,
        },
      }
      DataPolicyService.updatePolicy(getPayloadCheck(), config).then(res => {
        console.log("Habeas data update")
      })
    }
  }

  const handleChangeChecks = (e, index) => {
    changeCheck(index, e.target.checked)
  }

  const handleReset = () => {
    setusernameValue(defaultusernameValue)
    setmailValue(defaultmailValue)
    setphoneValue(defaultphoneValue)
    setactiveOption(defaultactiveOption)
    setquestionValue(defaultquestionValue)
    setshowSuccessQuestion(false)
    setactiveLoader(false)
  }

  const isDefaultValues = () => {
    return (
      defaultusernameValue === usernameValue &&
      defaultmailValue === mailValue &&
      defaultphoneValue === phoneValue &&
      defaultactiveOption === activeOption &&
      defaultquestionValue === questionValue
    )
  }

  const mistakeCellByCountry = num => {
    return (
      num.toString().length < parseInt(process.env.MIN_DIGITS) ||
      num.toString().length > parseInt(process.env.MAX_DIGITS)
    )
  }

  const haveErrors = () => {
    /* ----- draw errors ----- */
    if (isAllChecksTrue()) {
      settycError(true)
    } else {
      settycError(false)
    }

    if (usernameValue === "" || usernameValue === " ") {
      setusernameError(true)
    } else {
      setusernameError(false)
    }

    if (phoneValue === "") {
      setphoneError(true)
      setphoneErrorValue("*Este campo es requerido")
    } else {
      if (mistakeCellByCountry(phoneValue)) {
        setphoneError(true)
        setphoneErrorValue("*Número inválido")
      } else {
        setphoneError(false)
      }
    }

    if (mailValue === "") {
      setmailError(true)
      setmailErrorValue("*Este campo es requerido")
    } else if (!mailRegex.test(mailValue)) {
      setmailError(true)
      setmailErrorValue("*Correo inválido")
    } else {
      setmailError(false)
    }

    if (activeOption.name === "Selecciona el motivo") {
      setoptionError(true)
    } else {
      setoptionError(false)
    }

    if (questionValue === "" || questionValue === " ") {
      setquestionError(true)
    } else {
      setquestionError(false)
    }

    /* ----- draw errors ----- */

    /* ----- function flag ----- */
    return (
      isAllChecksTrue() ||
      usernameValue === "" ||
      usernameValue === " " ||
      (phoneValue === "" ? true : mistakeCellByCountry(phoneValue)) ||
      mailValue === "" ||
      !mailRegex.test(mailValue) ||
      activeOption.name === "Selecciona el motivo" ||
      questionValue === "" ||
      questionValue === " "
    )
    /* ----- function flag ----- */
  }
  return (
    <section className="f-question-section">
      <div className="f-section-position">
        {showSuccessQuestion ? (
          <div className="f-success-question">
            <label className="f-success-title">Pregunta enviada</label>
            <p className="f-success-description">
              <span className="f-bold">Gracias por enviarnos tu pregunta,</span>{" "}
              pronto recibirás la respuesta.
            </p>
            <div onClick={handleReset}>
              <Button
                title="Preguntar otra vez"
                className="primary-blue alter fit"
              />
            </div>
          </div>
        ) : (
          <>
            <div className="f-title-container">
              <label className="f-title">
                ¿No encontraste lo que buscabas?
                <span className="f-pink-section">
                  {process.env.LOCALE === "es-PY"
                    ? "preguntanos"
                    : "pregúntanos"}
                </span>
              </label>
            </div>

            <form
              className="f-form-question"
              onSubmit={e => handleSubmit(e)}
              autoComplete="off"
            >
              <div className="f-input-group">
                <label className="f-input-label ">TU NOMBRE</label>
                <input
                  type="text"
                  className={
                    "f-input-question " + (usernameError ? "input-error" : "")
                  }
                  name="f-name-input"
                  value={usernameValue}
                  onChange={e => {
                    setusernameValue(e.target.value.replace(/ {2}/g, " "))
                  }}
                />
                {usernameError && (
                  <label className="f-label-error">
                    *Este campo es requerido
                  </label>
                )}
              </div>
              <div className="f-input-group">
                <label className="f-input-label">TU CORREO</label>
                <input
                  value={mailValue}
                  type="text"
                  className={
                    "f-input-question " + (mailError ? "input-error" : "")
                  }
                  name="f-mail-input"
                  onChange={e => {
                    setmailError(false)
                    setmailValue(e.target.value.replace(/ /g, ""))
                  }}
                />
                {mailError && (
                  <label className="f-label-error">{mailErrorValue}</label>
                )}
              </div>
              <div className="f-input-group">
                <label className="f-input-label">TU NÚMERO CELULAR</label>
                <input
                  type="text"
                  className={
                    "f-input-question " + (phoneError ? "input-error" : "")
                  }
                  name="f-tel-input"
                  maxLength={process.env.MAX_DIGITS}
                  value={phoneValue}
                  onChange={e => {
                    setphoneValue(e.target.value.replace(/\D/, ""))
                  }}
                />
                {phoneError && (
                  <label className="f-label-error">{phoneErrorValue}</label>
                )}
              </div>
              <div className="f-input-group">
                <label className="f-input-label">MOTIVO DE CONSULTA</label>
                <div
                  className={
                    "f-input-question f-fake-select " +
                    (optionError ? "input-error" : "")
                  }
                  onClick={() => setactiveSelect(true)}
                >
                  <label className="f-label-inside">{activeOption.name}</label>
                  <span className="f-icon icon-down" />
                  {optionError && (
                    <label className="f-label-error option-label">
                      *Elije una opción
                    </label>
                  )}

                  {activeSelect && (
                    <ul className="f-collapse-menu">
                      {options.map((option, index) => {
                        return (
                          <li
                            className="f-item-option"
                            key={index}
                            onClick={e => {
                              e.stopPropagation()
                              setactiveSelect(false)
                              setactiveOption(option)
                            }}
                          >
                            {option.name}
                          </li>
                        )
                      })}
                    </ul>
                  )}
                </div>
              </div>

              <div className="f-input-group f-textarea-group">
                <label className="f-input-label">TU PREGUNTA</label>
                <textarea
                  type="text"
                  className={
                    "f-textarea-question " +
                    (questionError ? "input-error" : "")
                  }
                  name="f-name-textarea"
                  maxLength="300"
                  value={questionValue}
                  onChange={e => {
                    if (
                      !/^[ a-zA-Z0-9#°áéíóúÁÉÍÓÚäëïöüÄËÏÖÜñÑ,.;:()¿?¡!_-]+$/.test(
                        e.target.value
                      )
                    ) {
                      return false
                    } else {
                      setquestionValue(e.target.value.replace(/ {2}/g, " "))
                    }
                  }}
                ></textarea>
                {questionError && (
                  <label className="f-label-error">
                    *Este campo es requerido
                  </label>
                )}
              </div>

              <div className="f-button-input-group">
                <div className="f-step-question-checkBox-group">
                  {checksPolicy.map((item, index) => {
                    // si es distinto a mis puntos
                    if (item.idPrincipal !== "pbAccepted") {
                      return (
                        <div
                          className="f-step-question-form-checkBox"
                          key={item.idPrincipal}
                        >
                          <input
                            onChange={e => {
                              handleChangeChecks(e, index)
                            }}
                            type="checkbox"
                            name="terms"
                            value="Bike"
                          />
                          <p className="f-step-question-form-checkBox-copy">
                            <a
                              className="f-step-question-form-link"
                              rel="noopener noreferrer"
                              target="_blank"
                              href={homeLink + item.redireccion}
                            >
                              {item.tituloPrincipal}
                            </a>
                          </p>
                          <span className="f-checkmark"></span>
                        </div>
                      )
                    }
                  })}

                  {tycError && (
                    <label className="f-label-error">
                      *Debes aceptar para continuar
                    </label>
                  )}
                  <DataPolicy />

                  <div className="f-button-container">
                    {activeLoader ? (
                      <Loader
                        type="TailSpin"
                        color="#FF409B"
                        height={50}
                        width={50}
                      />
                    ) : (
                      <div onClick={handleSubmit}>
                        <Button
                          title="Enviar pregunta"
                          className="primary-blue alter fit"
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </form>
          </>
        )}
      </div>
    </section>
  )
}

export default FormQuestion
